export enum EMenuItemType {
  Link = 'link',
  Header = 'header',
  Divider = 'divider',
  Categories = 'categories',
}
